// URL paths are kept identical to the production client so bookmarks and the links the
// backend puts into e-mails (`/auth/login`, `/tickets/:id`) keep working.
export const routes = {
  login: '/auth/login',
  home: '/',
  practiceDashboard: '/practice-dashboard',
  practiceReport: '/practice-dashboard/report',
  appointmentStatistics: '/appointment-statistics',
  newPatientStatistics: '/new-patient-statistics',
  utilization: '/utilization-table',
  patientMap: '/patient-map',
  versionHistory: '/practice-version-history',
  users: '/users',
  userAdd: '/users/add',
  userEdit: '/users/edit/:id',
  userLoginHistory: '/users/:id/login-history',
  loginHistory: '/login-history',
  profile: '/profile',
  tickets: '/tickets',
  ticketCreate: '/tickets/create',
  ticketDetail: '/tickets/:ticketId',
  botConfiguration: '/bot-configuration',
  scriptRunner: '/bot-configuration/script-runner',
  analytics: '/analytics',
  analyticsCalls: '/analytics/calls',
  analyticsAppointmentTracking: '/analytics/appointment-tracking',
  analyticsLocationSite: '/analytics/location-site',
  analyticsReviews: '/analytics/reviews',
  forbidden: '/403',
  notFound: '/404',
  serverError: '/500',
} as const;

/** Builders for parameterised routes. */
export const paths = {
  userEdit: (id: number | string) => `/users/edit/${id}`,
  userLoginHistory: (id: number | string) => `/users/${id}/login-history`,
  ticketDetail: (id: number | string) => `/tickets/${id}`,
};

/** Landing page after sign-in (production `VITE_APP_DEFAULT_ROUTE` default). */
export const defaultRoute = routes.practiceDashboard;
